import React from 'react';

interface InfoFieldProps {
  label: string;
  value: React.ReactNode;
  className?: string;
}

/**
 * A standardized component for displaying labeled information in detail views
 */
const InfoField: React.FC<InfoFieldProps> = ({ label, value, className = '' }) => {
  return (
    <div className={`${className}`}>
      <div className="text-sm text-gray-500">{label}</div>
      <div className="font-medium">{value}</div>
    </div>
  );
};

export default InfoField; 